const initialState = {
    data:[],
    hospital: [],
    country:[],
    state:[],
    name:[],
    hcountry:[],
    image:[],
    himage:[], 
    
  };
  
  const SuprivisorProfileReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_DATA1_SUCCESS':
            return {... state, hospital:action.payload};
            case 'FETCH_COUNTRY_SUCCESS':
            return {... state, country:action.payload};
            case 'FETCH_STATE_SUCCESS':
            return {... state, state:action.payload};
            case 'FETCH_NAME_SUCCESS':
            return {... state, name:action.payload};
            case 'FETCH_SNAME_SUCCESS':
            return {... state, hcountry:action.payload};
            case 'FETCH_IMAGE_SUCCESS':
            return {... state, image:action.payload};
            case 'FETCH_HIMAGE_SUCCESS':
            return {... state, himage:action.payload};
          


      default:
        return state;
    }
  };
  
  export default SuprivisorProfileReducers;
  
  